import React from "react";
import { FaAsterisk, FaEdit } from "react-icons/fa";
import EditEmergencyContact from "./EditEmergencyContact";
import Skeleton from "react-loading-skeleton";

const EmergencyContact = ({ userProfile, isLoading, refetch }) => {
  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="small-text font-weight-bold">
          Emergency Contact Information:
        </h4>
        <button
          className="btn btn-outline-primary btn-edit-user-profile"
          data-toggle="modal"
          data-target="#editEmergencyContact"
        >
          <FaEdit size={16} className="mr-2" /> Edit
        </button>
        <EditEmergencyContact
          userProfile={userProfile}
          isLoading={isLoading}
          refetch={refetch}
        />
      </div>
      {isLoading && <Skeleton width={100} height={20} />}
      <div className="row small-text">
        {!isLoading &&
          userProfile?.emergencyContacts &&
          userProfile?.emergencyContacts.map((contact, index) => (
            <div className={`col-md-6 mb-3`} key={index}>
              <div className="row">
                <div className="col-md-3">
                  <p>Full Name:</p>
                </div>
                <div className="col-md-7 d-flex">
                  <p className="font-weight-bold">
                    {contact.lastName} {contact.firstName}
                  </p>
                  <div className="ml-3">
                    {contact.preferred && (
                      <div className=" badge_pomme bg_primary f-10 text-light rounded-pill d-flex align-items-center justify-content-center">
                        <span>Preferred Emergency Contact</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <p>Relationship:</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">{contact.relationship}</p>
                </div>
              </div>
              <div className="row my-2">
                <div className="col-md-6">
                  <p className="font-weight-bold">
                    {contact.streetAddress}, {contact.suite} {contact.city},{" "}
                    {contact.province}, {contact.country} {contact.postalCode}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <p>Home Phone Number:</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">{contact.homePhoneNumber}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <p>Work Phone Number:</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">{contact.workPhoneNumber}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <p>Mobile Phone Number:</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">
                    {contact.mobilePhoneNumber}{" "}
                    <sup>
                      <FaAsterisk className="text_primary" />
                    </sup>
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default EmergencyContact;
